import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";

const iconThemeColor = (WrappedComponent) => {
  return (props) => {
    const theme = useTheme();
    const [hover, setHover] = useState(false);
    const defaultColor = theme.palette.mode === "dark" ? "#ffffffff" : "#000000";
    const hoverColor = props.hoverColor || props.color || defaultColor;
    const fillColor = hover ? hoverColor : props.color || defaultColor;
    const width = props.width || "24px";
    const height = props.height || "24px";

    return (
      <span
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
      >
        <WrappedComponent {...props} fillColor={fillColor} width={width} height={height} />
      </span>
    );
  };
};

export default iconThemeColor;
